import { useEffect, useState } from "react";
import { X, Info, CheckCircle2, AlertTriangle } from "lucide-react";
import { API } from "@/lib/api";

const STYLES = {
  info: "bg-primary text-primary-foreground",
  success: "bg-emerald-600 text-white",
  warning: "bg-amber-500 text-black",
};
const ICONS = { info: Info, success: CheckCircle2, warning: AlertTriangle };

export function SiteAnnouncement() {
  const [ann, setAnn] = useState(null);

  useEffect(() => {
    let ok = true;
    fetch(`${API}/announcement/active`)
      .then((r) => r.json())
      .then((d) => {
        if (!ok) return;
        const a = d.announcement;
        if (a && localStorage.getItem("ns_ann_dismissed") !== a.id) setAnn(a);
      })
      .catch(() => {});
    return () => { ok = false; };
  }, []);

  if (!ann) return null;
  const Icon = ICONS[ann.type] || Info;
  const dismiss = () => {
    localStorage.setItem("ns_ann_dismissed", ann.id);
    setAnn(null);
  };

  return (
    <div data-testid="site-announcement" className={`${STYLES[ann.type] || STYLES.info} px-4 py-2.5`}>
      <div className="mx-auto flex max-w-7xl items-center gap-3">
        <Icon className="h-4 w-4 shrink-0" />
        <p className="flex-1 text-sm font-600">
          {ann.message}
          {ann.link && (
            <a href={ann.link} target="_blank" rel="noreferrer" className="ml-2 font-800 underline underline-offset-2">
              {ann.link_text || ann.link}
            </a>
          )}
        </p>
        <button onClick={dismiss} data-testid="announcement-dismiss" aria-label="Dismiss"
          className="shrink-0 rounded-full p-1 transition-colors hover:bg-black/10">
          <X className="h-4 w-4" />
        </button>
      </div>
    </div>
  );
}
